import api from '../../../utils/api'

export const getAppointmentsApi = (data) => api.get('/admin/transactions', { params: data })
export const getAppointmentByIdApi = (id) => api.get(`/admin/transactions/${id}`)
export const getExportedTableApi = (data) => api.get('/admin/export_transactions', { params: data })
export const deleteAppointmentApi = (id) => api.delete(`/admin/transactions/${id}`)
export const paymentRefundApi = (transaction_id) => api.post('/admin/refunds', { transaction_id })
